import { render, staticRenderFns } from "./EchartsArea.vue?vue&type=template&id=13dd5a90&"
import script from "./EchartsArea.vue?vue&type=script&lang=js&"
export * from "./EchartsArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports